import { Outlet, ScrollRestoration } from 'react-router-dom'
import { Suspense } from 'react'
import { ErrorBoundary, LoadingScreen } from '@repo/ui'
import OfflineAlert from '@/features/offline/components/OfflineAlert'
import FailedQueryNotifications from '@/features/errors/notifications/FailedQueryNotifications'
import Header from './parts/Header'
import Footer from './parts/Footer'

export default function Layout() {
  const testIdInit = `layout`

  return (
    <ErrorBoundary>
      <Suspense
        fallback={
          <LoadingScreen data-testid={`${testIdInit}-suspense-loading`} />
        }
      >
        <Header />
        <ErrorBoundary>
          <main className="container flex flex-col">
            <Suspense
              fallback={
                <LoadingScreen
                  data-testid={`${testIdInit}-main-suspense-loading`}
                />
              }
            >
              <OfflineAlert data-testid={`${testIdInit}-offline-alert`} />
              <FailedQueryNotifications
                data-testid={`${testIdInit}-failed_queries`}
              />
              <Outlet />
            </Suspense>
          </main>
        </ErrorBoundary>
        <Footer />
        <ScrollRestoration />
      </Suspense>
    </ErrorBoundary>
  )
}
